'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentBitcoinLogoAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M61.4017 33.8365C58.7295 44.5566 47.8685 51.0731 37.1638 48.4008C26.4435 45.7286 19.9269 34.8679 22.5992 24.1635C25.2714 13.4434 36.1168 6.92695 46.8371 9.59915C57.5418 12.2557 64.074 23.1165 61.4017 33.8365Z",
          fill: "url(#paint0_linear_647_4458)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M51.5226 26.5078C51.9133 23.8516 49.8976 22.4141 47.1164 21.4609L48.0226 17.8516L45.8351 17.3047L44.9601 20.8203C44.382 20.6797 43.7883 20.5391 43.1945 20.4141L44.0695 16.8828L41.882 16.3359L40.9914 19.9297C40.507 19.8203 40.0383 19.7109 39.5851 19.6016V19.5859L36.5539 18.8359L35.9758 21.1797C35.9758 21.1797 37.6008 21.5547 37.5695 21.5703C38.4601 21.7891 38.6164 22.3828 38.5851 22.8516L37.5539 26.9609C37.6164 26.9766 37.6945 26.9922 37.7883 27.0391C37.7101 27.0234 37.632 27.0078 37.5539 26.9766L36.1164 32.7266C36.007 32.9922 35.7258 33.3984 35.1164 33.2422C35.132 33.2734 33.5226 32.8516 33.5226 32.8516L32.4289 35.3672L35.2883 36.0859C35.8195 36.2266 36.3351 36.3516 36.8508 36.4922L35.9445 40.1328L38.132 40.6797L39.0383 37.0703C39.632 37.2266 40.2258 37.3828 40.7883 37.5234L39.8976 41.1172L42.0851 41.6641L42.9914 38.0234C46.7414 38.7266 49.5539 38.4453 50.7258 35.0547C51.6789 32.3359 50.6789 30.7578 48.7101 29.7266C50.1633 29.3984 51.2414 28.4453 51.5226 26.5078ZM46.507 33.5391C45.8351 36.2578 41.2414 34.7891 39.757 34.4141L40.9601 29.5859C42.4445 29.9609 47.2258 30.6953 46.507 33.5391ZM47.1945 26.4609C46.5695 28.9453 42.757 27.6797 41.5226 27.3672L42.6164 22.9922C43.8508 23.3047 47.8351 23.8828 47.1945 26.4609Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
        "linearGradient",
        {
          id: "paint0_linear_647_4458",
          x1: 41.9893,
          y1: 8.99058,
          x2: 41.9893,
          y2: 48.996,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { stopColor: "#F9AA4B" }),
            /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#F7931A" })
          ]
        }
      ) })
    ]
  }
);
const VpPaymentBitcoinLogoAsset = forwardRef(PaymentBitcoinLogoAsset);

export { VpPaymentBitcoinLogoAsset as default };
